import { apiCall } from "../services/api";
import { Alert } from "rsuite";

export const scannedTracking = (body) => {
  const url = `${process.env.REACT_APP_API}/driver/scantracking`;
  return apiCall("post", url, body) //upload file to fileserver
    .then((resp) => resp)
    .catch((err) => Alert.error(err.message));
};
